import * as React from 'react';
import styled from "styled-components";
import {Title, SectionTitle, Button} from "../../styled"
import Item from "./componetns/Item";
import {navigateTo} from "helpers/navigate-to";

const Header = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 40px;
`;

const Content = styled.div`
  max-width: 719px;
`;

const IdeaBox = styled.div`
  display: grid;
  gap: 30px;
  max-width: 360px;
  margin-top: 18px;
`;

const IdeaText = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0.01em;
  color: #4F4F51;
`;

const IdeaButton = styled(Button)`
  display: flex;
  width: max-content;
  border-radius: 5px;
  padding: 10px 20px;
  background: #3264EF;
`;

const Container = styled.div`
  margin-left: 90px;
  width: 100%;
  max-width: 1160px;

  ${Title} {
    max-width: 686px;
  }

  @media screen and (max-width: 1270px) {
    margin: 0;

    ${IdeaButton} {
      margin-bottom: 20px;
    }

    ${IdeaBox} {
      gap: 14px;
      margin-top: 10px;
    }

    ${IdeaButton} {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      min-width: 300px;
      height: 49px;
    }
  }
`;

/**
 * render landing page stages section
 * @constructor
 */
export default function Stages(): React.ReactElement {
  return (
    <Container>
      <Header>
        <div>
          <SectionTitle>ЭТАПЫ РАБОТЫ НАД ПЛАТФОРМОЙ</SectionTitle>
          <Title>
            У нашей команды есть четкое видение,
            каким должен быть <br/>продукт через
            <span> 5 лет</span>
          </Title>
        </div>
        <IdeaBox>
          <IdeaText>
            Мы ориентируемся на наших пользователей,
            учитываем их пожелания и опыт.
            Сделайте нас счастливее,
            а платформу более удобную и функциональную,
            поделившись своим мнением.
            Также с радостью рассмотрим все идеи для реализации.
          </IdeaText>
          <IdeaButton onClick={() => navigateTo('landing.feedback')}>Предложить идею</IdeaButton>
        </IdeaBox>
      </Header>
      <Content>
        <Item
          year={2023}
          items={[
            {
              title: 'Пятый этап',
              description: 'Встроенный конструктор сайтов и дизайна школы. Вводим детальную аналитику для всех данных, от реакций на трансляции и обучения и собираем данные.'
            },
            {
              title: 'Четвертый этап',
              description: 'Мобильное приложение для телефонов, планшетов и ТВ, отраслевые решения - для иностранных языков, программирования, и т.д. Расширяем границы и возможности применения.'
            },
            {
              title: 'Третий этап',
              description: 'Улучшение и добавление новых: раздел маркетинга, которому нет аналогов: автоматизация, воронки, чат-боты, рассылки, реферальные программы - все, что выведет продажи и сервис онлайн обучения на новый уровень.'
            },
            {
              title: 'Второй этап',
              description: 'Улучшение ф-ии и удобства текущих, и добавление новых: моя школа, внутренние чаты, сертификаты, геймификация, мульти-язычность. Интеграция ведущих мировых платежных систем.'
            }
          ]}
        />
        <Item
          year={2021}
          items={[
            {
              title: 'Запуск с первым этапом функций:',
              description: 'Мобильное приложение для телефонов, планшетов и ТВ, отраслевые решения - для иностранных языков, программирования, и т.д. Расширяем границы и возможности применения.'
            }
          ]}
        />
        <Item
          year={2020}
          items={[
            {
              title: 'Старт разработки платформы для всех пользователей',
              description: 'Разработка продукта, бренда и стратегии.'
            }
          ]}
        />
        <Item
          year={2018}
          items={[
            {
              title: 'Начало разработки для собственных нужд',
              lastElement: true,
            }
          ]}
        />
      </Content>
    </Container>
  );
}
